import { useEffect, useState } from "react";
import { socket } from "@/shared/config/socket";
import { formatUSD } from "@/shared/utils/ultils";


const SelectMarketMB = () => {
    const [marketId, setMarketId] = useState(1);
    const [showSelect, setShowSelect] = useState(false);
    const [markets, setMarkets] = useState([]);
    useEffect(() => {
            socket.on('get_prices', (data: any) => {
                setMarkets(data)
            })
    }, [])

    const marketActive: any = markets?.find((item: any) => item?.id === marketId);

    return <div className="mb-2">
        {/* <div className="mb-2" style={{ color: "#fff", fontSize: 14 }}>Chọn hàng hoá</div> */}
        <div onClick={() => setShowSelect(!showSelect)} className="px-2 px-3 rounded-3 cursor-pointer d-flex justify-content-between position-relative align-items-center" style={{ fontSize: 14, background: "rgb(7, 15, 33)", color: "#fff", border: "none", boxShadow: "none", paddingTop: 10, paddingBottom: 10}}>
            <div>
                <img className="rounded-circle me-2" width={25} src={`https://faofood.com/assets/images/commodity/` + marketActive?.image} />
                {marketActive?.name}
            </div>
            <div>
                {formatUSD(marketActive?.price)}
            </div>
            <div>
                {marketActive?.twenty_four_hour_change}% {marketActive?.twenty_four_hour_change > 0 ? <i style={{  color: "hsl(152 69% 31%)" }} className="fa-solid fa-arrow-trend-up"></i> :  <i style={{ color: "hsl(354 70% 54%)" }} className="fa-solid fa-arrow-trend-down"></i> }
            </div>

            <div className="box-select-tiente-1 w-100" style={{ top: -325, display: showSelect ? 'block' : 'none'}}>
                {
                    markets?.map((item: any, index: number) => (
                        <div className="py-3 px-3 item d-flex justify-content-between align-items-center" key={index} onClick={() => setMarketId(item?.id)}>
                            <div>
                                <img className="rounded-circle me-2" width={25} src={`https://faofood.com/assets/images/commodity/` + item?.image} />
                                {item?.name}
                            </div>
                            <div>
                                {formatUSD(item?.price)}
                            </div>
                            <div>
                                {item?.twenty_four_hour_change}% {item?.twenty_four_hour_change > 0 ? <i style={{  color: "hsl(152 69% 31%)" }} className="fa-solid fa-arrow-trend-up"></i> :  <i style={{ color: "hsl(354 70% 54%)" }} className="fa-solid fa-arrow-trend-down"></i> }
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
  </div>
}

export default SelectMarketMB;